import { connect } from 'react-redux';

import CobrandingFixedHeader from 'legacy/components/CobrandingFixedHeader.jsx';

import { getCobrandingData } from 'selectors/personalization';
import { getIsLessThanSmallMedium } from 'selectors/match-media';

const mapStateToProps = (state, ownProps) => {
  const isMobile = getIsLessThanSmallMedium(state);
  return {
    cobrandingData: getCobrandingData(state),
    isMobile
  };
};

export default connect(mapStateToProps)(CobrandingFixedHeader);
